import ProgressBar from "../../Atoms/ProgressBar/ProgressBar";
import {useRef, useState} from "react";
import {QuestionList} from "../../Models/Question";
import ButtonContainer from "./ButtonContainer";
import {Header} from "./SelectionHeader";
import "./SelectPage.scss"
import FloatingWrapper from "../../Atoms/Floating/FloatingWrapper";
import GreenBtn from "../../Atoms/Buttons/GreenBtn";
import WhiteBtn from "../../Atoms/Buttons/WhiteBtn";
import CheckBoxContainer from "./CheckBoxContainer";
import {useNavigate} from "react-router-dom";
import styled from "styled-components"
import {ReactComponent as Icon} from "./InfoIcon.svg";
import BlackBtn from "../../Atoms/Buttons/BlackBtn";

const getWidthRatio = (q) => {
  return ((q.depth) / 3) * 100 - 5;
}

export default () => {
  let navigate = useNavigate();

  const [index, setIndex] = useState(0);
  const [prevIndexList, setPrevIndexList] = useState([]);
  const [nextIndex, setNextIndex] = useState(null);

  const [log, setLog] = useState(null);

  const q = QuestionList[index];
  const widthRatio = getWidthRatio(q);
  const click = (e) => {
    let index = e.target.dataset.index;
    if (index !== "gift") {
      index = Number(index);
    }
    setNextIndex(index);

    /* for logging */
    setLog(e.target.dataset.log);
  }
  const checkList = useRef(null);
  const logObj = useRef({});

  const getNext = () => {
    if (q.type === "check") {
      const checkedList = [];
      logObj.current[q.question] = [];
      checkList.current.childNodes.forEach(elem => {
        const checkBox = elem.querySelector("div");
        if (elem.querySelector("div").classList.contains("checked")) {
          checkedList.push(checkBox.dataset.value);
          logObj.current[q.question].push(checkBox.dataset.log);
        }
      })
      if (checkedList.length === 0) {
        alert("선택해주세요")
      } else {
        const result = checkedList.reduce((a, b) => a > b ? a : b)
        navigate("/nb/result", {state: {result, logObj}})
      }
    } else if (nextIndex === "gift") {
      logObj.current[q.question] = log;

      navigate("/nb/gift", {state: {logObj}})
    } else if (nextIndex !== null) {
      logObj.current[q.question] = log;

      setPrevIndexList([...prevIndexList, index]);
      setIndex(nextIndex);
    } else {
      alert("선택해주세요")
    }
  }

  const getPrev = () => {
    if (prevIndexList.length !== 0) {
      delete logObj.current[q.question];

      const newPrev = [...prevIndexList];
      const newCur = newPrev.pop();
      setIndex(newCur);
      setPrevIndexList(newPrev);
      setNextIndex(null);
    } else {
      navigate("/")
    }
  }

  return (
    <Wrapper className={"selection-wrapper"}>
      <ProgressBar widthRatio={widthRatio} isLast={q.isLast}/>
      <Header>
        {q.question}
        {q.isLast && <span> <br/> *다중 선택 가능</span>}
      </Header>
      {
        q.type === "check" ? <CheckBoxContainer selections={q.selections} checkList={checkList}/> :
          <ButtonContainer selections={q.selections} click={click} btnSize={q.btnSize}/>
      }
      {q.selections.map((selection, idx) => (
        <div key={selection.descTitle + "selection" + idx}>
          {selection.descTitle && <DescWrapper
            descTitle={selection.descTitle}
            descList={selection.descList}
          />}
        </div>
      ))}
      <FloatingWrapper>
        <WhiteBtn onClick={getPrev}>이전</WhiteBtn>
        <BlackBtn isActive={!!nextIndex} onClick={getNext}>다음</BlackBtn>
      </FloatingWrapper>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  padding-bottom: 80px;
`

const DescWrapper = ({descTitle, descList}) => {
  return (
    <Div>
      <Title>
        <Icon/>
        {descTitle}
      </Title>
      <ContentList>
        {descList.map((item, idx) => <ContentItem key={item + idx}>{item}</ContentItem>)}
      </ContentList>
    </Div>
  )
}

const Div = styled.div`
  width: 328px;
  margin: auto;
  margin-top: 16px;
  flex-grow: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 8px;
  padding: 16px;
  background-color: #F6F9FA;
`
const Title = styled.p`
  display: flex;
  align-items: end;
  margin: 0;
  font-family: "Pretendard";
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.4;
  letter-spacing: 0.02px;
  text-align: left;
  color: #2f3031;
`

const ContentList = styled.ul`
  margin: 0;
  padding: 0;
  padding-left: 20px;
  width: 296px;
  margin: auto;
`

const ContentItem = styled.li`
  width: 280px;
  font-family: "Pretendard";
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.4;
  letter-spacing: 0.02px;
  text-align: left;
  color: #2f3031;
`